var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLineDown = function SvgIconArrowLineDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20.25a1 1 0 0 0 1 1h16.5a1 1 0 1 0 0-2H3.75a1 1 0 0 0-1 1M11.293 17.957a1 1 0 0 0 1.414 0l6.75-6.75a1 1 0 0 0-1.414-1.414L13 14.836V3a1 1 0 1 0-2 0v11.836L5.957 9.793a1 1 0 0 0-1.414 1.414z"
  }))));
};
export default SvgIconArrowLineDown;